module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.participant) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-layout-inner childCourseBlock"
  }, [_c('div', {
    staticClass: "title-block-alt"
  }, [_c('div', {
    staticClass: "alt-container"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.participant.full_name) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, _vm._l((_vm.participant.items), function(item) {
    return _c('booking-item', {
      key: item.id,
      attrs: {
        "bookingId": _vm.booking_id,
        "participant": _vm.participant,
        "item": item
      },
      on: {
        "update": _vm.update
      }
    })
  })), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "full-width-cta"
  }, [_c('router-link', {
    staticClass: "cta-button red",
    attrs: {
      "to": {
        name: 'booking.quickadd',
        params: {
          venueId: _vm.participant.items[0].venue_id,
          childId: _vm.participant.items[0].participant_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$parent.$parent.locale.button_quick_add_more))])], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2a3eeb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Basket/BasketItem.vue
// module id = 194
// module chunks = 0